// extracted by mini-css-extract-plugin
export default {"iconWrapper":"PasswordSubmitted_iconWrapper__h2X-t"};